export const TICKET_VALUE_QUANTITY = 'quantity';
export const TICKET_VALUE_OPEN_PRICE = 'openPrice';

export const TICKET_EMAIL = 'tixEmail';
